export const boxShippingSoonInitiated = () => ({
  type: `View Too Late To Change Delivery Date page`,
});

export const boxShippingSoonBackDashboard = () => ({
  type: `Click back to dashboard`,
});
